import { StyleDetail as StyleDetailModal } from "./StyleDetail"

export default StyleDetailModal
